import {useQuery} from '@tanstack/react-query';
import getG2ReviewStatus from '@/api/fetchers/g2ReviewStatus';

export default function useG2ReviewStatus(enabled: boolean) {
  return useQuery({
    queryKey: ['g2ReviewStatus'],
    queryFn: getG2ReviewStatus,
    enabled,
    retry: false,
    refetchOnWindowFocus: false,
  });
}
